import { LoginDetails } from '@/travelsuit'
import { EmptyVoidCallback, VoidCallback } from '@/travelsuit/callback'
import { SessionInfo } from '@/types/auth'
import { UserId } from '@/types/common'
import { User } from '@/types/user'
import { ObFeeMockValue } from '@/types/userNew'

import { IAction } from './action-helpers'
import { AuthTypes as Types } from './actions.types'

export const Actions = {
	internalLogin(
		params?: { sso_registration?: boolean },
		callback?: VoidCallback<LoginDetails>,
		errCallback?: VoidCallback,
	): IAction {
		return {
			type: Types.InternalLogin.REQUEST,
			params,
			callback,
			errCallback,
		}
	},
	finishLogin(authResult: auth0.Auth0DecodedHash, callback?: EmptyVoidCallback, errCallback?: VoidCallback): IAction {
		return {
			payload: authResult,
			type: Types.LoginDone,
			callback,
			errCallback,
		}
	},
	failLogin(): IAction {
		return {
			type: Types.LoginError,
		}
	},
	finishLogout(): IAction {
		return {
			type: Types.LogoutDone,
		}
	},
	setInternalUser(user: User, loginData?: Omit<LoginDetails, 'user'>): IAction {
		return {
			payload: { user, loginData },
			type: Types.SetInternalUser,
		}
	},
	setTermsAccepted(accepted: boolean): IAction {
		return {
			payload: accepted,
			type: Types.SetTermsAccepted,
		}
	},
	getSessionInfo(callback?: VoidCallback<SessionInfo>, errCallback?: VoidCallback): IAction {
		return {
			type: Types.SessionInfo.REQUEST,
			callback,
			errCallback,
		}
	},
	updateSession(callback?: VoidCallback, errCallback?: VoidCallback): IAction {
		return {
			type: Types.UpdateSession.REQUEST,
			callback,
			errCallback,
		}
	},
	showModal() {
		return {
			type: Types.ShowModal,
		}
	},
	hideModal() {
		return {
			type: Types.HideModal,
		}
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setIsMockEnabled(userId: UserId, value: boolean): IAction<{ userId: UserId; value: boolean }, any, User> {
		return {
			type: Types.SetIsMockEnabled.REQUEST,
			payload: { userId, value },
		}
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setIsTokenizerMockEnabled(userId: UserId, value: boolean): IAction<{ userId: UserId; value: boolean }, any, User> {
		return {
			type: Types.SetIsTokenizerMockEnabled.REQUEST,
			payload: { userId, value },
		}
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setIsWorldlineMockEnabled(userId: UserId, value: boolean): IAction<{ userId: UserId; value: boolean }, any, User> {
		return {
			type: Types.SetIsWorldlineMockEnabled.REQUEST,
			payload: { userId, value },
		}
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setIsFlightSearchMockEnabled(userId: UserId, value: boolean): IAction<{ userId: UserId; value: boolean }, any, User> {
		return {
			type: Types.SetIsFlightSearchMockEnabled.REQUEST,
			payload: { userId, value },
		}
	},
	setIsObFeeMockEnabled(userId: UserId, value: ObFeeMockValue | null): IAction {
		return {
			type: Types.SetIsObFeeMockEnabled.REQUEST,
			payload: { userId, value },
		}
	},
}
